<template>
  <GmapMap
    :center="{ lat, lng }"
    :zoom="16"
    class="full-width google-map-height"
    :class="confirmedPageDesktop ? 'confirmed-page-map-height' : '' "
    ref="mapRef"
    :options="{
      disableDefaultUI: true
    }"
  >
    <GmapMarker
      :icon="{
        url: markerIcon + '#custom_marker',
        labelOrigin: google && new google.maps.Point(15, -45),
        ...(this.$route.name === 'confirmed' &&
          google && { scaledSize: new google.maps.Size(29, 29) }),
        //scaledSize: this.$route.name === 'confirmed' ? google && new google.maps.Size(29, 29) : '',
      }"
      :label="{ text: `${storeName}\n${formattedAddress}`, className: 'custom-label' }"
      :position="{ lat, lng }"
      :clickable="false"
      :draggable="false"
      @click="center = { lat, lng }"
    />
  </GmapMap>
</template>

<script>
import { mapState } from "vuex";
import { gmapApi } from "gmap-vue";

export default {
  name: "GoogleMap",
  props: { confirmedPageDesktop: Boolean, customerLat: Number, customerLng: Number },
  computed: {
    google: gmapApi,
    ...mapState({
      storeLat: (state) => {
        return state.store && state.store.info ? parseFloat(state.store.info.lat) : 0;
      },
      storeLng: (state) => {
        return state.store && state.store.info ? parseFloat(state.store.info.lng) : 0;
      },
      storeName: (state) => state.store?.info.name,
      address: (state) =>
        state.store && state.store.info ? state.store.info.singleline : null,
      storeImage: (state) => state.store?.info.image,
      customerAddress: state => state.orderStatus.localOrderAddress,
      bringgOrderStep: (state) => state.orderStatus.bringgOrderResponse.orderStep,
    }),
    formattedAddress() {
      if (this.customerAddress && this.bringgOrderStep === 4) return this.customerAddress.replace(", USA", "");
      return this.address ? this.address.replace(", USA", "") : "";
    },
    markerIcon() {
      return this.$route.name === "confirmed"
        ? this.storeImage
        : require("@/assets/spotlight-pin.png");
    },
    lat() {
      if (this.bringgOrderStep !== 4) return this.storeLat;
      return this.customerLat;
    },
    lng() {
      if (this.bringgOrderStep !== 4) return this.storeLng;
      return this.customerLng;
    },
  },

  watch: {
    bringgOrderStep: function() {
      if (this.bringgOrderStep !== 4) return;
      this.panToLocation(this.lat, this.lng);
    },
  },
  methods: {
    panToLocation(newLat, newLng) {
      const mapInstance = this.$refs.mapRef.$mapObject;
      const newPosition = new window.google.maps.LatLng(newLat, newLng);
      mapInstance.panTo(newPosition);
    },
  },
};

</script>

<style lang="scss" scoped>

.google-map-height {
  height: 100%;
}

.confirmed-page-map-height {
  height: 560px;
}

:deep(img[src$="#custom_marker"]){
  border: 3px solid var(--v-secondary-base) !important;
  border-radius:50%;
}
:deep(.custom-label) {
  color: white!important;
  white-space: break-spaces;
  background-color: var(--v-secondary-base);
  border-radius: 8px;
  padding: 4px;
  position: relative;
  box-shadow: #00000050 0 0 10px 2px;
}
:deep(.custom-label)::after {
  content: "";
  position: absolute;
  top: 119%;
  left: 50%;
  margin-left: -8px;
  border-width: 8px;
  border-style: solid;
  border-color: var(--v-secondary-base) transparent transparent transparent;
  scale: 1 2;
}
</style>
